import * as React from "react";
import { SVGProps } from "react";

export const GoogleMeetSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={20}
		height={20}
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M10.9847 9.87126L12.4469 11.5425L14.4129 12.7989L14.7557 9.88154L14.4129 7.0293L12.4091 8.13317L10.9847 9.87126Z"
			fill="#00832D"
		/>
		<path
			d="M2.5 12.5279V15.0133C2.5 15.5816 2.96023 16.0418 3.52845 16.0418H6.01388L6.52811 14.1631L6.01388 12.5279L4.30836 12.0137L2.5 12.5279Z"
			fill="#0066DA"
		/>
		<path
			d="M6.01388 3.69922L2.5 7.2131L4.30836 7.72733L6.01388 7.2131L6.51954 5.60014L6.01388 3.69922Z"
			fill="#E94235"
		/>
		<path d="M6.01388 7.21484H2.5V12.5285H6.01388V7.21484Z" fill="#2684FC" />
		<path
			d="M16.6584 5.1879L14.413 7.02883V12.7985L16.6687 14.648C17.0064 14.9119 17.5 14.6711 17.5 14.2417V5.58557C17.5 5.15105 16.9952 4.91279 16.6584 5.1879ZM10.9848 9.87079V12.5276H6.01392V16.0415H13.3845C13.9527 16.0415 14.413 15.5813 14.413 15.0131V12.7985L10.9848 9.87079Z"
			fill="#00AC47"
		/>
		<path
			d="M13.3845 3.70117H6.01392V7.21506H10.9848V9.87189L14.413 7.03165V4.72963C14.413 4.1614 13.9527 3.70117 13.3845 3.70117Z"
			fill="#FFBA00"
		/>
	</svg>
);
